module.exports = __webpack_public_path__ + "static/DariusA-e5a924396d759de093191c087678470a.gif";